const  router = [
	{
		path: "/staff/layout",
		component: () => import('../../../pages/staff/Layout.vue'),
		meta: {title: '员工'},
		name: 'staffIndex',
		children:[
			{
				path: "/staff",
				component: () => import('../../../pages/staff/Account.vue'),
				meta: {title: '员工管理', type:'c', permission: 'staff_index'},
				name: 'staffIndex',
			},
			// {
			// 	path: "/room",
			// 	component: () => import('../../../pages/mendian/Room.vue'),
			// 	meta: {title: '房间管理', type:'c', permission: 'room_index'},
			// 	name: 'room_index',
			// },
			
		],
	}
];

export default router